import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './lang/zh.js'
import en from './lang/en.js'
import th from './lang/th.js'
import vn from './lang/vn.js'
import my from './lang/my.js'


Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('lang') || 'zh',
  messages: {
	  'zh': zh,
	  'en': en,
    'th': th,
    'vn': vn,
    'my': my,
  },
  silentTranslationWarn: true,
})

export default i18n
